var _path, _path2, _path3, _path4, _path5, _rect, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSapphireTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6533 16.8793C35.2523 17.2803 35.0513 17.7673 35.0513 18.3403C35.0513 18.9133 35.2523 19.4003 35.6533 19.8013C36.0543 20.2023 36.5413 20.4023 37.1143 20.4023V24.5273C37.1143 25.1013 36.9133 25.5873 36.5123 25.9883C36.1113 26.3903 35.6243 26.5903 35.0513 26.5903H14.4263C13.8533 26.5903 13.3663 26.3903 12.9663 25.9883C12.5643 25.5873 12.3643 25.1013 12.3643 24.5273V20.4023C12.9373 20.4023 13.4243 20.2023 13.8253 19.8013C14.2263 19.4003 14.4263 18.9133 14.4263 18.3403C14.4263 17.7673 14.2263 17.2803 13.8253 16.8793C13.4243 16.4783 12.9373 16.2773 12.3643 16.2773V12.1523C12.3643 11.5803 12.5643 11.0933 12.9663 10.6923C13.3663 10.2913 13.8533 10.0903 14.4263 10.0903H35.0513C35.6243 10.0903 36.1113 10.2913 36.5123 10.6923C36.9133 11.0933 37.1143 11.5803 37.1143 12.1523V16.2773C36.5413 16.2773 36.0543 16.4783 35.6533 16.8793Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6533 16.8793C35.2523 17.2803 35.0513 17.7673 35.0513 18.3403C35.0513 18.9133 35.2523 19.4003 35.6533 19.8013C36.0543 20.2023 36.5413 20.4023 37.1143 20.4023V24.5273C37.1143 25.1013 36.9133 25.5873 36.5123 25.9883C36.1113 26.3903 35.6243 26.5903 35.0513 26.5903H14.4263C13.8533 26.5903 13.3663 26.3903 12.9663 25.9883C12.5643 25.5873 12.3643 25.1013 12.3643 24.5273V20.4023C12.9373 20.4023 13.4243 20.2023 13.8253 19.8013C14.2263 19.4003 14.4263 18.9133 14.4263 18.3403C14.4263 17.7673 14.2263 17.2803 13.8253 16.8793C13.4243 16.4783 12.9373 16.2773 12.3643 16.2773V12.1523C12.3643 11.5803 12.5643 11.0933 12.9663 10.6923C13.3663 10.2913 13.8533 10.0903 14.4263 10.0903H35.0513C35.6243 10.0903 36.1113 10.2913 36.5123 10.6923C36.9133 11.0933 37.1143 11.5803 37.1143 12.1523V16.2773C36.5413 16.2773 36.0543 16.4783 35.6533 16.8793Z",
    stroke: "#6B696A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9272 10.0903V11.5903",
    stroke: "#6B696A",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9272 14.2871V23.7251",
    stroke: "#6B696A",
    strokeWidth: 1.5,
    strokeDasharray: "2.7 2.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9272 25.0737V26.5737",
    stroke: "#6B696A",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.6057L2.2981 8.9615L5.15385 3.25H18.8461L21.7019 8.9615L12 20.6057ZM9.22112 8.25H14.7789L13.0288 4.74995H10.9711L9.22112 8.25ZM11.25 17.3673V9.74995H4.92112L11.25 17.3673ZM12.75 17.3673L19.0789 9.74995H12.75V17.3673ZM16.4461 8.25H19.6539L17.9038 4.74995H14.6961L16.4461 8.25ZM4.34612 8.25H7.55385L9.30387 4.74995H6.09615L4.34612 8.25Z",
    fill: "#188DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapphireTicket);
export default __webpack_public_path__ + "static/media/sapphire_ticket.f390c62c0c7ec0e0bb5c4bf4526e1292.svg";
export { ForwardRef as ReactComponent };